import * as de from './locale/de-DE/index.js';
export const locale = {
  'de-DE': de,
  'de-AT': de,
  'de-CH': de,
  /**
   * @todo: add translations!
   */
  'cs-CZ': de,
  'hu-HU': de,
  'sk-SK': de,
  'pl-PL': de
};